import { instance as axios, setJwtToken, setMultiPartHeader } from "../../config/axiosInstance"

//---------------------hash-tags-listing------------------------------
export const getHashTagsApi = async (data) => {
    const endPoint = `/hash_tag/list` + `?` + new URLSearchParams({ ...data }).toString()
    return await axios.get(endPoint, setJwtToken())
}

//--------------------add-hash-tags-------------------------------
export const addHashtagApi = async (data) => {
    const endPoint = `/hash_tag/add`
    return await axios.post(endPoint, data, setMultiPartHeader())
}

//--------------------add-hash-tags-------------------------------
export const deleteHashtagApi = async (id) => {
    const endPoint = `/hash_tag/delete/${id}`
    return await axios.delete(endPoint, setJwtToken())
}